import React from 'react';
import ReportsPage from '../Reports';

export default function TicketsCustom() {
  return <ReportsPage />;
}

